import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme, transientOptions } from "@product/scmp-sdk";

import { ArticleImage } from "~/components/article/article-image";
import {
  DescriptionContainer as ArticleImageDescription,
  StyledImage as ArticleImageImg,
} from "~/components/article/article-image/styles";
import { ImageStyle } from "~/components/content/content-schema-render/image/enums";

type ImageProps = {
  $imageHeight?: string;
  $imageStyle?: ImageStyle;
  $imageWidth?: string;
};

type ImageWithRelativeHeightProps = {
  $relativeHeight?: number;
} & ImageProps;

const setWidthByImageProps = (props: ImageProps) => {
  if (!props.$imageStyle) return;
  const styleMap = {
    [ImageStyle.Full]: css`
      inline-size: 100%;
    `,
    [ImageStyle.Fixed]: css`
      inline-size: ${props.$imageWidth}px;
      max-inline-size: 100%;

      ${theme.breakpoints.up("tablet")} {
        max-inline-size: 451px;
        margin-inline: auto;
      }
    `,
    // Ref: https://project.scmp.tech/product/web/scmp-pwa/-/issues/2198
    [ImageStyle.Other]: css`
      inline-size: 100%;

      ${theme.breakpoints.up("desktop")} {
        ${Number.parseInt(props.$imageWidth ?? "0", 10) <= 440 &&
        css`
          inline-size: ${props.$imageWidth}px;
          margin-inline: auto;
        `}
      }
      ${theme.breakpoints.only("tablet")} {
        ${Number.parseInt(props.$imageWidth ?? "0", 10) <= 487 &&
        css`
          inline-size: ${props.$imageWidth}px;
          margin-inline: auto;
        `}
      }
    `,
  };
  return styleMap[props.$imageStyle];
};

export const StyledArticleImage = styled(ArticleImage, {
  ...transientOptions,
})<ImageWithRelativeHeightProps>(
  props => css`
    ${ArticleImageImg} {
      cursor: pointer;

      object-fit: cover;
    }

    ${ArticleImageImg}, ${ArticleImageDescription} {
      ${setWidthByImageProps(props)}
    }
  `,
);

export const Container = styled.div`
  position: relative;
`;
